import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const twoFaEnabledState = atom({
  key: "twoFaEnabledState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
